import { Component, Input, OnInit } from '@angular/core';
import { TransactionDetails } from 'src/app/shared/interfaces/User';

@Component({
  selector: 'app-user-card-top-up',
  templateUrl: './user-card-top-up.component.html',
  styleUrls: ['./user-card-top-up.component.scss'],
})
export class UserCardTopUpComponent implements OnInit {
  @Input() details: any | null | undefined;

  constructor() {}

  ngOnInit(): void {}
}
